import React, { useContext } from "react";
import { AppHelper } from "../../App";
import ExitX from "../UI/ExitX";
import LocalizationJSON from "../../localization/localization.json";
import { LanguageContext } from "../../App";
import classes from "./AboutOverlay.module.css";

import AllLogos from "../UI/AllLogos";

function AboutOverlay(props) {
  let localizationJSON = LocalizationJSON;
  let langcontext = useContext(LanguageContext);

  const imgpath = `${AppHelper.storageUrl}media/domifederowicz_foto.jpg`;

  const renderLink = (a) => {
    const links = {
      1: localizationJSON.about_links1,
      2: localizationJSON.about_links2,
      3: localizationJSON.about_links3,
      4: localizationJSON.about_links4,
    };
    const linkContent = links[a] || links[1];

    const logos = [
      "etykietkilogo",
      "emaillogo",
      "linkedinlogo",
      "instagramlogo",
    ];

    let b = a - 1;
    const selectedlogo = logos[b];

    // return (
    //   <div>{AppHelper.ReturnLanguageContent(linkContent, langcontext)}</div>
    // );

    //Work in progress F#08 in Taiga - logos

    console.log(linkContent.content);

    return (
      <div href={linkContent.content} className={classes.linkcontainer}>
        <AllLogos
          selectedlogo={selectedlogo}
          width={25}
          height={25}
          fill="#7B858C"
        ></AllLogos>
        <a href={linkContent.content} className={classes.linktext}>
          {AppHelper.ReturnLanguageContent(linkContent, langcontext)}
        </a>
      </div>
    );
  };

  return (
    <div className={classes.main}>
      <div className={classes.exitmain} onClick={props.switchOverlay}>
        <ExitX />
      </div>

      <div className={props.viewAboutOverlay ? classes.show : classes.hide}>
        <div className={classes.grid}>
          <div className={classes.topfill}></div>
          <img
            className={classes.img}
            src={imgpath}
            alt="Dominika Federowicz photo"
          ></img>
          <div className={classes.textpanel}>
            <div className={classes.description}>
              {AppHelper.ReturnLanguageContent(
                localizationJSON.about_description,
                langcontext
              )}
            </div>
          </div>

          <div className={classes.links}>
            {renderLink(1)}
            {renderLink(2)}
            {renderLink(3)}
            {renderLink(4)}
          </div>
          <div className={classes.bottomfill}></div>
        </div>
      </div>
    </div>
  );
}

export default AboutOverlay;
